module.exports = __webpack_public_path__ + "img/base_hebergements_location_meublee.46785a17.svg";